import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "@/shared/components/RouteError";
import { RoutePending } from "@/shared/components/RoutePending";

const searchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

/**
 * @purpose Compare fleet KPIs across all customers for a date range
 * @primary KPI totals table, one row per customer
 * @persona falk-ceo, xavi-coo
 */
export const Route = createFileRoute("/app/admin/kpis/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
